import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { M_Button } from "../../../../M_Components";
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "../item.css";
import { genericEntityService } from '../../../../services/genericEntityService';

export const AttachmentFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;
    const fileInputRef = useRef(null);
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const [fileSizeExceeded, setFileSizeExceeded] = useState(null);
    const file = itemForm.form[field.Code];

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (field.MaxFileSizeInBytes !== null && file.size > field.MaxFileSizeInBytes) {
            setFileSizeExceeded(true);
            changeValueCallback({
                ...itemForm,
                errors: {
                    ...itemForm.errors,
                    [field.Code]: t('NgeInvalidRange')
                }
            });
            return;
        }
        setFileSizeExceeded(false);
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: e.target.files[0],
            },
            errors: {
                ...itemForm.errors,
                [field.Code]: null
            }
        });
    }

    const handleFileDownload = (filename, attachmentId) => {
        genericEntityService.getFile(attachmentId)
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(link);
            })
            .catch(function (error) { });
    }

    return (
        <div className="attachment">
            {
                !isDisabled && <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <M_Button
                            label={field.Captions[currentLanguage]?.length >= 0 ? `${field.Captions[currentLanguage]} ${field.IsMandatory ? '*' : ''}` : `${field.Code} ${field.IsMandatory ? '*' : ''}`}
                            borderColor={'var(--color-blue)'}
                            labelColor={'var(--color-black)'}
                            icon={<div style={{ color: 'var(--color-blue)' }}><CloudUploadIcon /></div>}
                            onClick={handleButtonClick}
                        />

                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                        <span>
                            ({t("NgeMaxSize")} {field.MaxFileSizeInBytes} bytes) <br />
                            {fileSizeExceeded && <>
                                {t("NgeFileSizeExceeded")}
                            </>}
                            {file?.name !== undefined ? file?.name + " - " + file?.size + "bytes" : ""}
                        </span>
                    </div>
                </>
            }
            {
                isDisabled && <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span>
                            {field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}:
                            <a className="link" style={{ cursor: 'pointer' }} onClick={() => handleFileDownload(
                                itemForm.form[field.Code]?.FileName || itemForm.form[field.Code]?.fileName,
                                itemForm.form[field.Code]?.AttachmentId || itemForm.form[field.Code]?.attachmentId
                            )}>
                                {itemForm.form[field.Code]?.FileName || itemForm.form[field.Code]?.fileName}
                            </a>
                        </span>
                    </div>
                </>
            }


        </div>
    )
}